// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useState } from 'react';
import { Chapter, Note } from '../../../../types/Model';
import LoadingIcon from '../../../LoadingIcon';
import { useCurrentModule } from '../../hooks';
import ChapterTab from './ChapterTab';
import NoteTab from './NoteTab';
import { S } from './styles';

interface SidebarProps {
  chapters: Chapter[];
  chaptersIsFetching: boolean;
  notes?: Note[];
  isNoteFetching?: boolean;
  noteError?: Error;
  name: string;
  /** Online course id or workshop id  */
  courseId: number;
  courseType?: string;
  handleCreateNote?: (message: string) => void;
  handleDeleteNote?: (noteId: string) => void;
  handleUpdateNote?: (noteId: string, message: string) => void;
  handleFetchNote?: () => void;
  handleSeek?: (seconds: number) => void;
  setPlaying?: (playing: boolean) => void;
}

enum TabType {
  Chapter = 'F001',
  Note = 'F002'
}

const Sidebar: React.FC<SidebarProps> = (props):JSX.Element => {
  const {
    name,
    courseId,
    chapters,
    chaptersIsFetching,
    notes,
    isNoteFetching,
    noteError,
    courseType,
    handleCreateNote,
    handleDeleteNote,
    handleUpdateNote,
    handleFetchNote,
    handleSeek,
    setPlaying,
  } = props;
  const [isOpened, setIsOpened] = useState(true);
  const [currentTab, setCurrentTab] = useState<TabType>(TabType.Chapter);

  const handleOpen = () => {
    setIsOpened(!isOpened);
  }

  const currentModule = useCurrentModule(chapters);

  const renderContent = (currentTab:TabType) => {
    switch (currentTab) {
      case TabType.Chapter:
        if (chaptersIsFetching) {
          return renderIsFetching();
        } else {
          return <ChapterTab courseId={courseId} chapters={chapters} />
        }
      case TabType.Note:
        if (courseType === 'iltCourses') {
          return null
        }
        if (isNoteFetching) {
          return renderIsFetching();
        } else {
          return <NoteTab
            currentModule={currentModule}
            notes={notes}
            noteError={noteError}
            handleCreateNote={handleCreateNote}
            handleDeleteNote={handleDeleteNote}
            handleUpdateNote={handleUpdateNote}
            handleFetchNote={handleFetchNote}
            handleSeek={handleSeek}
            setPlaying={setPlaying}
          />
        }
      default:
        return null;
    }
  }

  const renderIsFetching = () => {
    return (
      <S.LoadingContainer>
        <LoadingIcon size={20} />
      </S.LoadingContainer>
    )
  }

  return (
    <S.Wrapper isOpened={isOpened}>
      <S.CloseContainer onClick={handleOpen}>
        <S.CloseIcon isOpened={isOpened}/>
      </S.CloseContainer>
      <S.Container>
        <S.Title>{name}</S.Title>
        <S.Tabs tabs={courseType === 'iltCourses' ? ['F001'] : Object.values(TabType)} currentTab={currentTab} handleChangeTab={tab => setCurrentTab(tab as TabType)} />
        <S.ContentContainer>
          {renderContent(currentTab)}
        </S.ContentContainer>
      </S.Container>
    </S.Wrapper>
  );
}

export { Sidebar as default };
